import { QuestionFieldSaveModel } from './../shared/models/question-save-model';
export class SaveStageModel {   
    
    constructor(fields,stageLuid){
        this.fields=fields;
        this.stageLuid=stageLuid;
    }
    // FIELDS
    public fields: QuestionFieldSaveModel[];
    // STAGELUID
    public stageLuid: number;
}


// WEBPACK FOOTER //
// ./src/app/stages/stage-save.model.ts